import { FieldValidation } from '@atlassian/mpac-utils';

/*
 The validations added here are in sync with backend validations
 1. https://bitbucket.org/atlassian-marketplace/amkt/src/321d95139a3a9260586bf61ecaff0ee698286c6f/webapp/src/main/scala/com/atlassian/marketplace/http/VendorFieldValidation.scala#lines-70
 2. https://bitbucket.org/atlassian-marketplace/amkt/src/695f60048b901259d801e20f4dfe3c7663d48808/webapp/src/main/scala/com/atlassian/marketplace/http/VendorFieldValidation.scala#lines-46
*/

/* 
  checks the field value to contain:
  1. values only in range 0020 to 007A (hex)
  2. not start with contain ()[]<>-
  3. not contain '*+:
*/
export const checkOptionalVendorPaymentField = name => value => {
  const trimmedValue = (value !== null && value !== void 0 ? value : '').trim();

  if (trimmedValue.match(/[^ -z]/) !== null) {
    return "".concat(name, " can only include following (A-Z) (a-z) (0-9) (/ . , _)");
  }

  if (trimmedValue.match(/^[()<>[\]-].*/) !== null) {
    return "".concat(name, " can not start with following characters: ( ) [ ] < > -");
  }

  if (trimmedValue.match(/['*+:]/) !== null) {
    return "".concat(name, " can not contain the following characters * + : '");
  }
};
/* 
  checks the field value to contain:
  1. not contain ()[]<>-
*/

export const checkPostCodeField = name => value => {
  if ((value !== null && value !== void 0 ? value : '').trim().match(/[()<>[\]{}-]/) !== null) {
    return "".concat(name, " can not contain the following characters ( ) { } [ ] < > -");
  }
};
/* 
  checks the field value to contain:
  1. not be a blank string
  2. checks against checkOptionalVendorPaymentField
*/

export const checkNonEmptyVendorPaymentField = name => value => {
  return FieldValidation.checkNonEmptyString(name)(value) || checkOptionalVendorPaymentField(name)(value);
};
export const getUpdatePaymentDetailsPayload = (fields, _links) => {
  var _fields$bankAccountTy;

  let paymentFields = {
    accountName: fields.accountName,
    accountNumberOrIban: fields.accountNumberOrIban,
    bankName: fields.bankName,
    bankCity: fields.bankCity,
    bankState: fields.bankState,
    bankIsoCountryCode: fields.bankCountry.abbr,
    bankAddress: fields.bankAddress,
    bankPincode: fields.bankPincode
  };

  if (fields.intermediaryBankId) {
    paymentFields = { ...paymentFields,
      intermediaryBankId: fields.intermediaryBankId
    };
  }

  if (fields.intermediaryBankName) {
    paymentFields = { ...paymentFields,
      intermediaryBankName: fields.intermediaryBankName
    };
  }

  if ((_fields$bankAccountTy = fields.bankAccountType) !== null && _fields$bankAccountTy !== void 0 && _fields$bankAccountTy.value) {
    paymentFields = { ...paymentFields,
      bankAccountType: fields.bankAccountType.value
    };
  }

  if (fields.routingNumber) {
    paymentFields = { ...paymentFields,
      routingNumber: fields.routingNumber
    };
  }

  if (fields.swiftCode) {
    paymentFields = { ...paymentFields,
      swiftCode: fields.swiftCode
    };
  }

  if (fields.localBankId) {
    paymentFields = { ...paymentFields,
      localBankId: fields.localBankId
    };
  }

  if (fields.specialHandlingNotes) {
    paymentFields = { ...paymentFields,
      specialHandlingNotes: fields.specialHandlingNotes
    };
  }

  let addressFields = {
    line1: fields.line1,
    city: fields.city,
    state: fields.state,
    postCode: fields.postCode,
    country: fields.country.abbr
  };

  if (fields.line2) {
    addressFields = { ...addressFields,
      line2: fields.line2
    };
  }

  return { ...(_links && {
      _links
    }),
    address: addressFields,
    contact: {
      email: fields.email,
      firstName: fields.firstName,
      lastName: fields.lastName,
      phoneNumber: fields.phoneNumber
    },
    payment: paymentFields,
    tax: {
      abnOrTaxId: fields.abnOrTaxId,
      isGSTRegistered: fields.isGSTRegistered
    }
  };
};